import { render, staticRenderFns } from "./coupon-opened-items.vue?vue&type=template&id=dd0893d2&scoped=true&lang=pug&"
import script from "./coupon-opened-items.vue?vue&type=script&lang=js&"
export * from "./coupon-opened-items.vue?vue&type=script&lang=js&"
import style0 from "./coupon-opened-items.vue?vue&type=style&index=0&id=dd0893d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0893d2",
  null
  
)

export default component.exports